// Cookies
const appname = "sdhcemr";
export const REMEMBER_ME_COOKIE_NAME = `${appname}_remember`;
export const TOKEN_COOKIE_NAME = `${appname}_token`;
export const LAST_USER = `${appname}_last_user`;
